import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { VehicleFlowController } from './vehicle-flow-controller.page';

const routes: Routes = [
  {
    path: '',
    component: VehicleFlowController,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VehicleFlowControllerPageRoutingModule {}
